// extracted by mini-css-extract-plugin
export default {"avatar":"ProjectTeamMember_avatar__-Co8q"};